var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lightbox"},[_c('div',{attrs:{"className":"lightbox__content-wrapper"}},[_c('div',{attrs:{"className":"lightbox__message"}},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('button',{staticClass:"lightbox__close",on:{"click":_vm.close_lightbox}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aeacc8d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/app/js/components/lightbox.vue
// module id = 58
// module chunks = 0